import 'twin.macro';
import React from 'react';
import H5 from '@teetsh/app/src/components/Typography/Headings/H5';
import H1 from '@teetsh/app/src/components/Typography/Headings/H1';
import { format } from '@teetsh/app/src/utils/time/format';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { useTranslation } from 'react-i18next';

interface Props {
  schoolyearLabel: string;
  eleveFamilyName: string;
  eleveGivenName: string;
  livretName: string;
  eleveBirthday?: Date;
  periodeFrom: Date;
  periodeTo: Date;
  classroomName: string;
  classroomCycle: string;
}

export function LivretHeader(props: Props) {
  const { t } = useTranslation(['carnet', 'common']);
  const {
    schoolyearLabel,
    eleveGivenName,
    eleveFamilyName,
    livretName,
    eleveBirthday,
    classroomName,
    classroomCycle,
    periodeTo,
    periodeFrom,
  } = props;
  const { locale } = useUser();
  return (
    <div tw="text-center">
      <H5>{t('carnet:livret.schoolyear', { years: schoolyearLabel })}</H5>
      <H1>
        {eleveFamilyName} {eleveGivenName}
      </H1>
      {eleveBirthday && (
        <div tw="text-muted mb-2">
          {t('carnet:livret.bornOn', {
            date: format(
              eleveBirthday,
              locale,
              t('common:datePattern.dd/MM/yyyy'),
            ),
          })}
        </div>
      )}
      <div tw="font-semibold mb-2">
        {livretName} - {classroomCycle} -{' '}
        {t('carnet:livret.periodeRange', {
          from: format(periodeFrom, locale, t('common:datePattern.dd/MM/yyyy')),
          to: format(periodeTo, locale, t('common:datePattern.dd/MM/yyyy')),
        })}
      </div>
      <div>{t('carnet:livret.classOf', { classroomName })}</div>
    </div>
  );
}
